import styled from 'styled-components'
import { Colors } from 'cio-design-library/design-tokens'
import Media from 'builder/styles/media'
import Icon24 from 'builder/components/Icon'
import { FontWeights, Typography } from 'builder/styles/typography'

import { WidgetImage } from '../../widget.styles'
import ResumeDistributionImage from './assets/rd-icon.png'

export const IlustrationContainer = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  ${Media.Phone`
    padding-top: 24px;
    align-items: flex-start;
  `}
`

export const IlustrationImage = styled(WidgetImage)``

export const RdLogo = styled.div`
  position: absolute;
  top: -5px;
  left: -10px;
  width: 40px;
  height: 34px;
  transform: rotate(-31.5deg);
  background-image: url(${ResumeDistributionImage});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;

  ${Media.Phone`
    top: -14px;
    left: -12px;
    width: 22.557px;
    height: 19.174px;
    transform: rotate(-31.597deg);
  `}
`

export const IlustrationOuterCircle = styled.div`
  position: relative;
  width: 220px;
  height: 220px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100%;
  background: ${Colors.White};
  box-shadow: 0px 16px 64px rgba(15, 56, 113, 0.18), 0px 6px 8px rgba(15, 56, 113, 0.02),
    0px 0px 1px rgba(15, 56, 113, 0.32);

  ${Media.Phone`
    width: 187px;
    height: 120px;
    border-radius: 16px;
  `}
`

export const IlustrationInnerCircle = styled.div`
  width: 212px;
  height: 212px;
  border-radius: 100%;
  background: ${Colors.Neutral5};
  display: flex;
  align-items: center;
  justify-content: center;

  ${Media.Phone`
    width: 183px;
    height: 116px;
    border-radius: 16px;
  `}
`

export const RecruitersCountContainer = styled.div`
  width: 142px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`

export const CountContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  justify-content: flex-end;
  width: 80%;
`

export const CountText = styled.h2`
  ${Typography.L}
  ${FontWeights.Medium}

  color: ${Colors.Neutral90};
`

export const RecruitersText = styled.p`
  ${Typography.Caption}
  ${FontWeights.Regular}

  text-align: center;
  color: ${Colors.Neutral90};
`

export const UpperIconContainer = styled.div`
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100%;
  background: ${Colors.Green10};
`

export const UpperIcon = styled(Icon24.ArrowUp)`
  color: ${Colors.Green50};
`
